import { ActionType, getType } from 'typesafe-actions';
import { RequestState } from '../../constants/request-state';
import { EntityMapState } from '../../types/state/entities/EntityMapState';
import { Company } from '../../types/amr-pipeline/models/Company';
import { arrangersActions } from '../../actions/entities/arrangers.actions';
import { apiUtils } from '../../utils';

export const arrangersDefaultState: EntityMapState<string, Company> = {
    items: {},
    requestState: RequestState.none,
};

export type ArrangersActionTypes = ActionType<typeof arrangersActions[keyof typeof arrangersActions]>;

export function arrangersReducer(
    state = arrangersDefaultState,
    action: ArrangersActionTypes,
): EntityMapState<string, Company> {
    switch (action.type) {
        case getType(arrangersActions.request):
            return { ...state, requestState: action.payload.requestState };
        case getType(arrangersActions.response):
            return {
                requestState: action.payload.requestState,
                items: apiUtils.normalize(action.payload.arrangers, c => c.referenceName, c => c),
            };
        default:
            return state;
    }
}
